/**
 * Application initialization
 * Runs before React renders to handle domain redirects and session setup
 */

import { shouldRedirectToCanonical, redirectToCanonical } from "./domain";
import { initializeSession } from "./session";

/**
 * Initialize application
 * Returns true if app should continue rendering, false if redirecting
 */
export async function initializeApp(): Promise<boolean> {
  // Check for canonical domain redirect first
  if (shouldRedirectToCanonical()) {
    redirectToCanonical();
    return false; // Don't render, we're redirecting
  }
  
  // Initialize session management
  await initializeSession();
  
  return true;
}
